import { gettext } from '@eventbrite/i18n';
import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './RisingDemandBlock.module.scss';

export const RisingDemandBlock: React.FunctionComponent = () => {
    return (
        <div className={styles.rising_demand_container}>
            <div className={styles.rising_demand_top_section}>
                <Typography variant="heading-lg" className={styles.header}>
                    {gettext('Meet the rising demand')}
                </Typography>
                <Typography variant="body-lg" className={styles.description}>
                    {gettext(
                        'With improved personalization, it’s now easier than ever for people to find and buy tickets to events they’ll love through Eventbrite’s marketplace',
                    )}
                </Typography>
            </div>
            <div className={styles.demand_data}>
                <div className={styles.data_div}>
                    <Typography
                        variant="heading-xl"
                        className={styles.data_text}
                    >
                        93M
                    </Typography>
                    <p className={styles.data_description}>
                        {gettext('unique ticket buyers on Eventbrite in 2023')}
                    </p>
                </div>
                <div className={styles.data_div}>
                    <Typography
                        variant="heading-xl"
                        className={styles.data_text}
                    >
                        2x
                    </Typography>
                    <p className={styles.data_description}>
                        {gettext(
                            'the consumer reach of our closest competitor',
                        )}
                    </p>
                </div>
            </div>
            <Button
                variant="primary"
                size="responsive"
                onClick={() => {
                    window.location.href =
                        '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                }}
                className={styles.rising_demand_cta}
            >
                {gettext('Launch your next event')}
            </Button>
        </div>
    );
};
